import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LangService } from '../../../controller/lang-service';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-coming-soon',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './coming-soon.html',
  styleUrl: './coming-soon.css'
})
export class ComingSoon {

  lang = inject(LangService);
  fb = inject(FormBuilder);

  form = this.fb.group({
    email: ['']
  });


  features = [
  { emoji: '🧩', title: 'coming.features.workflow', desc: 'coming.features.workflowDesc' },
  { emoji: '🎨', title: 'coming.features.themes', desc: 'coming.features.themesDesc' },
  { emoji: '⚡', title: 'coming.features.realtime', desc: 'coming.features.realtimeDesc' },
  { emoji: '🧠', title: 'coming.features.customCode', desc: 'coming.features.customCodeDesc' }
];

onSubmit() {
  if (this.form.invalid) return;

  const email = this.form.value.email;

  const formData = new FormData();
formData.append('email', email ?? '');

  fetch('https://formspree.io/f/xwpbkork', {
    method: 'POST',
    body: formData,
    headers: {
      Accept: 'application/json',
    }
  })
  .then(response => {
    if (response.ok) {
      console.log('✅ Email sent!');
    } else {
      console.error('❌ Failed to send');
    }
  });
}




}
